import { Article, NavItem, VideoItem } from './types';

export const SAMPLE_ARTICLES: Article[] = [
  {
    id: '1',
    title: 'مستقبل العملية السياسية في السودان: تحديات وآمال',
    summary: 'يتناول هذا المقال التحديات الراهنة التي تواجه الانتقال الديمقراطي في السودان والسيناريوهات المتوقعة للمرحلة المقبلة في ظل التغييرات المتسارعة.',
    content: 'يواجه العقد الاجتماعي في السودان اليوم منعطفاً تاريخياً حرجاً يتطلب تفكيك الأبنية الاستبدادية القديمة وصياغة مسار دستوري جديد يقوم على قيم المواطنة المتساوية والاستنارة والوعي الجمعي الفعال.\nإن النكسات المتتالية التي شهدتها الفترات الانتقالية تؤكد بما لا يدع مجالاً للشك أن استباق استقرار المؤسسات الوطنية عبر صفقات محاصصة فوقية لن يثمر سوى عن صيغ هشة قابلة للتصدع والانهيار أمام أول عاصفة أمنية.\nيكمن المخرج الحقيقي في ترسيخ آليات حوار وطني شامل ومستدام يتجاوز الاستقطاب الجهوي، مدعوماً ببنية قضائية وقانونية مستقلة قادرة على مواءمة الطموحات الشعبية وتأسيس دولة المواطنة والمستقبل المدني للبلاد.',
    category: 'أخبار',
    publishedDate: '2026-05-01',
    author: 'نورالدين كوكى',
    imageUrl: '/src/assets/images/author_hero_image_1780432828583.png',
    views: 1250
  },
  {
    id: '2',
    title: 'لقاء خاص حول تطلعات الشباب السوداني',
    summary: 'حوار فكري مفتوح مع ممثلي الكيانات الشبابية والفاعلين المدنيين لمناقشة إعادة تنظيم وتوجيه الطاقات الثورية نحو التأسيس اللامركزي لبناء الدولة.',
    content: 'يبحث هذا اللقاء التفاعلي العميق دور الكتل الشبابية ولجان الأحياء في صياغة الفضاء العام والمساهمة الفكرية لتوليد بدائل سياسية وتنموية حقيقية تناسب طموحات وتطلعات الجيل المعاصر.\nيرى المتحدثون في هذا الحوار المعرفي أن المشكلة الجوهرية تكمن في انفصال النخب الحزبية الكلاسيكية عن المد الثوري المتجدد على الأرض، مما خلق ازدواجية بنيوية تعرقل الانتقال السلمي.\nتمخض الحوار عن ضرورة الانتقال من التظاهر والممانعة السلبية إلى مرحلة مأسسة الكيانات الشبابية وإنتاج مشروعات تنموية وثقافية تسهم في توجيه المجتمعات المحلية واستعادة سيادة العقل وحرية القرار.',
    category: 'حوارات',
    publishedDate: '2026-04-28',
    author: 'نورالدين كوكى',
    imageUrl: 'https://images.unsplash.com/photo-1551818255-e6e10975bc17?q=80&w=400&h=300&auto=format&fit=crop',
    views: 840
  },
  {
    id: 'h2',
    title: 'حوار مع د. أحمد الفهيم حول السياسات التعليمية',
    summary: 'نستعرض في هذا اللقاء مع الإكاديمي د. أحمد الفهيم رؤية نقدية لإعادة صياغة فلسفة التعليم وتحديث المناهج لتلائم التحديات المعرفية والتقنية الحديثة.',
    content: 'يشخص الدكتور أحمد الفهيم الأزمة الهيكلية للتعليم في السودان باعتبارها انعكاساً مباشراً لغياب فلسفة وطنية موحدة تسعى إلى تعزيز التفكير النقدي الحر وربط الأكاديميا بالواقع الإنتاجي.\nويرى أن المناهج التعليمية الحالية لا زالت أسيرة القوالب التقليدية التي تلقن المعارف ولا تنمي حواس البحث العلمي والابتكار وصناعة العقل التنويري، مما يسهم في زيادة الفجوة الرقمية.\nيطرح البروفيسور في نهاية المقابلة حزمة من التوصيات لإصلاح المؤسسات التعليمية، في مقدمتها إعادة إحياء البحث الأكاديمي المستقل وتوجيه الاستثمار نحو التعليم المهني والتقني المتقدم وتأصيل قيم التعايش السلمي دستوريًا.',
    category: 'حوارات',
    publishedDate: '2026-04-20',
    author: 'نورالدين كوكى',
    imageUrl: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=400&h=300&auto=format&fit=crop',
    views: 1200
  },
  {
    id: 'h3',
    title: 'مستقبل الاستثمار في السودان: حوار مع خبراء',
    summary: 'مناقشة استراتيجية مع نخبة من الخبراء حول آفاق التنمية الاقتصادية المرتكزة على الموارد الذاتية وكيفية خلق بيئة جاذبة للمستثمرين الوطنيين في مرحلة التعافي.',
    content: 'يركز هذا اللقاء الاقتصادي التحليلي على استقراء الإمكانيات الكامنة للثروات الطبيعية والزراعية في السودان ومحاولة إيجاد صيغة تشريعية حمائية تضمن استدامة الموارد العامة والعدالة التوزيعية.\nيوضح المحللون المشاركون في النقاش أن العقبة الكأداء أمام التعافي والاستثمار لا تكمن في شح الفرص، وإنما في ترهل القوانين والفساد العابر للمؤسسات وغياب الضمانات الدستورية السليمة.\nيتفق الخبراء على برنامج إصلاح مالي طموح يبدأ بإقرار الشفافية في إدارة عقود التعدين والنفط، وتطوير البنية الأساسية للنقل، ودعم المزارع الصغير لضمان نهضة زراعية حقيقية ومستقلة.',
    category: 'حوارات',
    publishedDate: '2026-04-15',
    author: 'د. عبدالله علي',
    imageUrl: 'https://images.unsplash.com/photo-1591115765373-520b7a2d7a59?q=80&w=400&h=300&auto=format&fit=crop',
    views: 950
  },
  {
    id: 'h4',
    title: 'دور الفن في تعزيز السلم الاجتماعي',
    summary: 'قراءة جمالية ونقدية في إسهامات المبدعين السودانيين في توظيف الفنون البصرية والموسيقية كأداة للمقاومة الثقافية والتعافي والتصالح الوطني.',
    content: 'يبحث هذا الطرح في كيفية تحول الفنون والآداب من كونها مظهراً ترفيهياً إلى كونها سلاحاً فكرباً ماضياً لتفكيك خطابات التعصب الطائفي وتجذير ثقافة التسامح والاستنارة.\nتستند الورقة إلى شواهد تاريخية ومعاصرة لكيف تلاحمت الألحان الشعبية والجداريات التعبيرية في الشوارع لصناعة وجدان جمعي ينبذ الحروب والدمار ويدعو لإعادة البناء المدني.\nيؤكد المبدعون المشاركون في هذا التحقيق الجمالي على حاجة البلاد إلى مأسسة المنصات الفنية المستقلة ورعاية الهويات الثقافية المتعددة للسودان كمصدر ثراء كوني لا بؤرة للنزاع.',
    category: 'حوارات',
    publishedDate: '2026-04-10',
    author: 'أ. مريم صالح',
    imageUrl: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?q=80&w=400&h=300&auto=format&fit=crop',
    views: 1560
  },
  {
    id: 'p1',
    title: 'تأملات في الهوية السودانية المعاصرة',
    summary: 'بحث فلسفي وتاريخي يستكشف غزارة وتنوع تلافيف الثقافة السودانية وتعدد روافدها الإفريقية والعربية ومآلات صياغة الذات الوطنية الجديدة.',
    content: 'تقوم هذه الدراسة على فرضية أساسية ترى أن تعثر النهضة السودانية يعود في عمقه إلى الفشل المتراكم في مصالحة الذات الوطنية مع تنوعها الثقافي والعرقي الهائل وإقصاء الروافد التاريخية المتجذرة.\nإن محاولات فرض هوية أحادية قسرية من قبل النخب المسيطرة تاريخياً لم تسفر إلا عن إشعال الحروب الطويلة وتعميق الانقسام الداخلي وتبدد المشاعر الوطنية المشتركة بين الأقاليم.\nيخلص الكاتب إلى أن سوداناً مستقراً لن يتأتى إلا بالاعتراف الكامل والدستوري بكافة الثقافات واللغات كإرث وطني جامع متساوي الحقوق وتأسيس عقد اجتماعي يحترم العقل التنويري والوجود المتبادل.',
    category: 'أقلام حرة',
    publishedDate: '2026-04-25',
    author: 'عادل إبراهيم',
    imageUrl: 'https://images.unsplash.com/photo-1523800503107-5bc3bd2a6f81?q=80&w=400&h=300&auto=format&fit=crop',
    views: 1120
  },
  {
    id: 'p2',
    title: 'الخرطوم: حكاية مدينة لا تنام رغم الجراح',
    summary: 'نص أدبي وسردي عميق يوثق لملاحم اليومي والصمود الوجداني في شوارع الخرطوم في مواجهة العواصف والتحولات الإنسانية الكبرى.',
    content: 'في هذا النص الإنساني الشاعري، يقتفي الكاتب نبض الحياة اليومية وحركات المقاومة الحية في ذاكرة المدينة وأزقتها العتيقة التي ترفض الاستسلام لمشاعر اليأس والاستلاب.\nتستعرض ثنايا السرد حكايا ملهمة لمواطنين بسطاء استطاعوا تحويل أحيائهم ومطابخهم الجماعية وتجمعاتهم الطوعية إلى حصون آمنة للتضامن والتكافل والتعايش الإنساني الفريد.\nرغم ثقل الخسائر وحجم الدمار الهيكلي البادي على معالم المدينة التاريخية، تظل الخرطوم برمزيتها الإنسانية والفكرية نقطة البدء لأي استنارة ووعي جماهيري يسعى لكتابة فجر جديد للوطن.',
    category: 'أقلام حرة',
    publishedDate: '2026-04-22',
    author: 'ليلى عثمان',
    imageUrl: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?q=80&w=400&h=300&auto=format&fit=crop',
    views: 2340
  },
  {
    id: 'p3',
    title: 'أدب المقاومة: حين تصبح الكلمة رصاصة',
    summary: 'مراجعة أدبية ونقدية للإنتاج الشعري والروائي السوداني كمرآة عاكسة لتطلعات الجماهير وصدى لأصوات الحرية في مواجهة شمولية الأنظمة.',
    content: 'تقرأ هذه المقالة النقدية في أدب النضال السوداني عبر عهود الديكتاتوريات المختلفة، مستشهدة بروائع عمالقة الشعر والأدب الذين أسسوا بأقلامهم للوعي الثوري المقاوم الممتد.\nلم تكن الكلمات في هذا السياق مجرد تصوير جمالي مجرد، بل كانت مشاعلاً هادية تنمي قوى التفكير النقدي لدى الأجيال وتفضح أساليب التشويه المعرفي والاستبداد السياسي والعقدي.\nتكشف الدراسة أن استعادة الكلمة الحرة لاستقلاليتها وبنائها الجمالي الرصين هو المقدمة الضرورية لحماية العقل الجمعي من دأب الدعاية الموجهة لشرعنة الشمولية والفساد.',
    category: 'أقلام حرة',
    publishedDate: '2026-04-18',
    author: 'محمد الحسن',
    imageUrl: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?q=80&w=400&h=300&auto=format&fit=crop',
    views: 890
  },
  {
    id: 'p4',
    title: 'العودة إلى الجذور: فلسفة الأرض والإنسان',
    summary: 'خواطر تحليلية تبحث في العلاقة الهيكلية بين الفلاح السوداني والأرض كمدخل لفهم التنمية البيئية والإنتاجية المستدامة.',
    content: 'تأخذنا هذه الخواطر في رحلة استقصائية حول كيفية مساهمة العودة الرشيدة للمشاريع الزراعية القروية في إنهاء التبعية الغذائية وتأمين ركائز السلم الأهلي الداخلي المهدد والهش.\nتجادل الكاتبة بأن تهميش الريف السوداني وهجرة الكفاءات الزراعية نحو المدن كرس مفاهيم الاقتصاد الاستهلاكي المشوه وأفقد المجتمعات ارتباطها الجذري والمنتج ببيئتها الخصبة والثرية.\nوتدعو الرؤية في ختامها إلى تبني نموذج تنموي بيئي يعيد الاعتبار لكرامة الفلاح السوداني، وإدخال التكنولوجيا المستدامة لتوليد عهد اقتصادي رصين يتجاوز كبوات الماضي.',
    category: 'أقلام حرة',
    publishedDate: '2026-04-12',
    author: 'سعاد أحمد',
    imageUrl: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=400&h=300&auto=format&fit=crop',
    views: 1450
  },
  {
    id: '3',
    title: 'تقرير ميداني عن الوضع الإنساني في مناطق النزاع',
    summary: 'تقرير توثيقي دقيق يبحث في تفاصيل الواقع المعيشي الشاق والتحولات الديموغرافية والاجتماعية في أقاليم النزوح الأكثر تضرراً.',
    content: 'يسلط هذا التقرير الاستقصائي الصارم الضوء على الأوضاع الإنسانية واللوجستية بالغة التعقيد في مناطق الشتات، ناقلاً شهادات وقائعية مؤلمة ومعبرة عما آلت إليه الأمور بالداخل والخارج.\nيرصد التقرير غياباً تاماً للخدمات الطبية والدوائية وتوقف سلاسل الإمداد الغذائي، بالرغم من الجهود التطوعية والمبادرات الإنسانية الاستثنائية التي تبذلها غرف الطوارئ المستقلة.\nويوجه التقرير نداء معرفياً وحقوقياً ملحاً إلى كافة الضمائر الحية والهيئات الدولية لتأسيس ممرات آمنة وتوفير الدعم المالي المباشر للمتطوعين لدرء منزلق أكبر مجاعة يشهدها القرن الحالي.',
    category: 'حوارات',
    publishedDate: '2026-04-25',
    author: 'نورالدين كوكى',
    imageUrl: 'https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?q=80&w=400&h=300&auto=format&fit=crop',
    views: 2100
  },
  {
    id: '4',
    title: 'بيان حول ضرورة تعزيز الوحدة الوطنية',
    summary: 'بيان تاريخي ومطالبة فكرية موجهة لكافة المكونات الثورية والمدنية للالتفاف حول ميثاق سياسي مستقل ينقذ البلاد من مخاطر التشظي والانهيار الهيكلي.',
    content: 'يأتي هذا الإعلان بمثابة جرس إنذار فكري ومبدئي لتذكير كافة القوى السياسية والمدنية بمسؤوليتها التأريخية والأخلاقية الراهنة لحماية كيان الدولة وبشريتها من التفتيت والحروب البينية المفتلعة.\nإن البقاء في خانة التمترس الحزبي وتصفية الحسابات السياسية الضيقة في هذه المرحلة المفصلية لهو خيانة حقيقية لدماء الشهداء وتطلعات ملايين الأبرياء الناشدين للسلام والاستقرار العادل والمدني.\nنناشد بالتوافق العاجل وغير المشروط على إستراتيجية وطنية جامعة تقود لإنهاء المظاهر العسكرية، وتحييد الخطاب العرقي والجهوي، واستعادة القرار السيادي المستقل لبناء سودان العقلانية والحرية.',
    category: 'البيانات',
    publishedDate: '2026-04-20',
    author: 'نورالدين كوكى',
    imageUrl: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?q=80&w=400&h=300&auto=format&fit=crop',
    views: 560
  },
  {
    id: '5',
    title: 'السودان بين مطرقة الحرب وسندان الأزمات الاقتصادية',
    summary: 'رؤية تحليلية للمأزق الراهن وكيفية الخروج من دائرة الصراع التي تعصف بمقدرات البلاد الاقتصادية والبشرية الأليمة.',
    content: 'تجابه الدولة السودانية اليوم أزمة اقتصادية هي الأقسى في تاريخها الحديث، متمثلة في التدمير الكامل للبنية التحتية والمؤسسات الاقتصادية الكبرى بقلب العاصمة والولايات الرئيسية والإنتاجية.\nتجاوزت الخسائر المباشرة وغير المباشرة مئات المليارات من الدولارات مع توقف شبه كامل للأنشطة الصناعية وشلل تام في القطاع المصرفي، مما يهدد استقرار الحد الأدنى للمعيشة بصورة غير مسبوقة.\nإن الحديث عن التعافي يستدعي بالضرورة وقفاً شاملاً للعمليات العدائية ومساهمات دولية وإقليمية جادة لترميم البنية الأساسية وإرساء نموذج تنموي واقتصادي يستمد قوته من العدالة اللامركزية.',
    category: 'مقالات الرأي',
    publishedDate: '2026-05-01',
    author: 'نورالدين كوكى',
    imageUrl: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?q=80&w=1280&h=720&auto=format&fit=crop',
    views: 3420
  },
  {
    id: '6',
    title: 'تفكيك الكراهية: الطريق الوحيد للتعايش السلمي',
    summary: 'لماذا نحتاج اليوم أكثر من أي وقت مضى إلى خطاب وطني جامع ينبذ القبلية والجهوية ويؤسس لمواطنة متساوية دستوريًا وأخلاقيًا.',
    content: 'يتفشى في الفضاء العام خطاب كراهية وتحريض جهوي وقبلي مستعر يهدد بتمزيق عرى المجتمع والمنظومة الوطنية برمتها ومصادرة مكتسبات الثورة المدنية الديمقراطية الكبرى.\nإن هذا الانحدار ليس ظاهرة عفوية، بل هو استراتيجية ممنهجة لزعزعة التلاحم وتفخيخ السلم الأهلي لتأجيل تشييد دولة الحقوق والمؤسسات الراسخة والحياد الإيجابي.\nيتحمل المثقفون وصناع الرأي مسؤولية صياغة بديل استناري يرسخ المواطنة المتساوية كالتزام دستوري رادع، يبدد سموم الانقسام لبناء وطن حر يسع الجميع دون إقصاء.',
    category: 'مقالات الرأي',
    publishedDate: '2026-04-29',
    author: 'د. عبدالله علي',
    imageUrl: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=1280&h=720&auto=format&fit=crop',
    views: 1890
  },
  {
    id: '7',
    title: 'المرأة السودانية: من منصات الثورة إلى دوائر صنع القرار',
    summary: 'قراءة في تراجع تمثيل المرأة في العمليات السياسية الأخيرة وضرورة استعادة دورها الريادي في بناء الدولة وصياغة المستقبل الديمقراطي.',
    content: 'سجلت المرأة السودانية صفحات من المجد والريادة في كافة الهبات المدنية والانتفاضات السلمية في السودان، مظهرة شجاعة استثنائية وثباتاً منقطع النظير في جبهات المقاومة والثورة.\nومع ذلك، فإن صياغة المشهد السياسي ومفاوضات تقاسم وممارسة السلطة تشهد ممارسة بطريركية وتهميشاً فجاً لوجودهن الفاعل، وهو ما يعيب نزاهة واستدامة قرارات السلم والتعافي والعدالة.\nلا يمكن تشييد ديمقراطية حقيقية أو عقد اجتماعي سليم دون شراكة كاملة وغير مشروطة للمرأة في إعادة هيكلة الدولة وتصميم سياساتها العامة في كافة المحافل الدستورية.',
    category: 'مقالات الرأي',
    publishedDate: '2026-04-27',
    author: 'أ. مريم صالح',
    imageUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1280&h=720&auto=format&fit=crop',
    views: 2560
  },
  {
    id: 'i1',
    title: 'نحو فلسفة سياسية جديدة للسودان المعاصر',
    summary: 'قراءة عميقة في التحولات الفكرية للمجتمع السوداني المعاصر تدعو لإعادة التأسيس الفلسفي للفضاء العام بناءً على قيم التنوير والاستنارة والفكر العقلاني الحر.',
    content: 'يبحث الدارس في هذه الأطروحة الجدلية شروط إحداث قطع إبستمولوجي معرفي واعي مع ممارسات الماضي وسلطة المفاهيم التقليدية التي أعاقت صعود تيار عقلاني حقيقي بالبلاد.\nتوضح القراءة التحليلية أن غياب المشروع الفكري المتكامل هو الثغرة الدائمة التي تسللت منها الشموليات لتأميم الفضاء العام وإلحاقه بمؤسسات القهر باسم العقائد الشمولية الماحية للتنوع.\nوتقترح الورقة بناء شبكات معرفية ومنتديات تنويرية مستقلة تسعى لتلاقح الرؤى العلمية وتوطين الفكر التنويري والفلسفي بوصفه شرطاً موضوعياً لتشييد ديمقراطية مستدامة تحترم الإنسان وتصون عقله الحصيف.',
    category: 'قضايا فكرية',
    publishedDate: '2026-05-02',
    author: 'د. ياسر التجاني',
    imageUrl: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?q=80&w=1280&h=720&auto=format&fit=crop',
    views: 3100
  },
  {
    id: 'i2',
    title: 'العلمانية والدين في الفضاء العام: حوار العقل والوجدان',
    summary: 'مقاربة رصينة وملهمة تعالج المفهوم الشائك للعلاقة بين المقدس والسياسي وتدعو لبناء حياد دستوري ومؤسسي يضمن كرامة الإنسان وتعدد قناعاته الفكرية والروحية.',
    content: 'يسعى الكاتب في هذا المنظور الفلسفي لرفع اللبس الاستقطابي والتشويه الفكري المثار عمداً حول قضايا الدين والدولة، موضحاً أن العلمانية الرشيدة تعني صون حرية الاعتقاد من تلاعب السياسيين واستغلال النخب.\nإن الحياد المؤسسي الإيجابي للدولة تجاه كافة المذاهب والأديان والأقليات هو الضامن الحصري لمنع تحويل الوجدان الديني السامي إلى مطية لكسب السلطة وصناعة تمييز مدني بين أبناء الشعب الواحد.\nوتدعو المقالة إلى توافق دستوري يستلهم تجارب الدول التعددية الناجحة حيث تصبح الدولة حامياً للمشترك الوطني الجامع، تاركة للفضاءات الخاصة حريتها المطلقة في التعبير الروحي المتراحم.',
    category: 'قضايا فكرية',
    publishedDate: '2026-04-30',
    author: 'أ. سامي محمد',
    imageUrl: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?q=80&w=1280&h=720&auto=format&fit=crop',
    views: 2840
  },
  {
    id: 'i3',
    title: 'أزمة المثقف السوداني ومزالق السلطة',
    summary: 'تحليل للدور الذي لعبه المثقفون في الحقب السياسية المختلفة وكيف يمكن استعادة استقلالية الفكر بعيداً عن الاستقطاب.',
    content: 'ينقب البحث في الجذور النفسية والسياسية لانزلاق فئات واسعة من النخب الفكرية نحو دوائر التبرير والتسويق للمشاريع الشمولية والديكتاتورية وتخاذلها عن الدفاع المستميت عن حرية الشعوب وسيادتها.\nويرى أن انكسار الضمير المعرفي وخدمته للسلطان يعد الطعنة الأشد في مسيرة التحرر، داعياً لإعادة مأسسة الاستقلالية الفكرية والأخلاقية للجامعات والمنصات المعرفية الحاضنة للفكر القويم.\nيبرز المقال أهمية العودة لروح النقد الجاد والمساءلة المستمرة كركيزة أولى لدور المثقف من أجل تشييد وعي شعبي نقي يقاوم الخضوع والاستلاب ويوجه مسيرة البناء بالبلاد والمنطقة.',
    category: 'قضايا فكرية',
    publishedDate: '2026-04-26',
    author: 'هبة الفاتح',
    imageUrl: 'https://images.unsplash.com/photo-1491841573634-28140fc7ced7?q=80&w=1280&h=720&auto=format&fit=crop',
    views: 1950
  }
];

export const VIDEO_DATA: VideoItem[] = [
  { id: 'v1', title: 'كلمة نورالدين كوكى في المؤتمر العام', thumbnailUrl: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1280&h=720&fit=crop', videoUrl: '#' },
  { id: 'v2', title: 'حوار تلفزيوني حول الديمقراطية', thumbnailUrl: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?q=80&w=400&h=300&fit=crop', videoUrl: '#' },
  { id: 'v3', title: 'تقرير عن مسيرة النضال السوداني', thumbnailUrl: 'https://images.unsplash.com/photo-1529070538774-1843cb3265df?q=80&w=400&h=300&fit=crop', videoUrl: '#' },
  { id: 'v4', title: 'مستقبل السلام في أفريقيا', thumbnailUrl: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=400&h=300&fit=crop', videoUrl: '#' }
];

export const MAIN_NAV: NavItem[] = [
  { label: 'الرئيسية', href: '/' },
  { label: 'الميدان الثورة', href: '/category/news' },
  { label: 'المقالات', href: '/articles', children: [
    { label: 'مقالات الرأي', href: '/category/opinion' },
    { label: 'زاوية الرأي', href: '/category/opinion-corner' }
  ]},
  { label: 'أقلام حرة', href: '/category/free-pens' },
  { label: 'قضايا فكرية', href: '/category/intellectual' },
  { label: 'حوارات', href: '/category/dialogues', children: [
    { label: 'المقابلات', href: '/category/interviews' }
  ]},
  { label: 'مرئيات', href: '/videos' },
  { label: 'من نحن', href: '/about' },
  { label: 'اتصل بنا', href: '/contact' }
];

export const WRITERS = [
  { 
    name: 'نورالدين كوكى', 
    role: 'كاتب وسياسي', 
    avatar: '/src/assets/images/author_hero_image_1780432828583.png',
    website: 'nouraldin.sd',
    email: 'contact@nouraldin.sd',
    socials: {
      facebook: 'https://facebook.com/noureddine.koki',
      twitter: 'https://twitter.com/noureddine_koki',
      linkedin: 'https://linkedin.com/in/noureddine-koki'
    }
  },
  { 
    name: 'د. هشام النور', 
    role: 'اقتصادي وباحث سياسي', 
    avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=200&h=200&fit=crop&face',
    website: 'hishamalnour.sd',
    email: 'contact@hishamalnour.sd',
    socials: {
      facebook: 'https://facebook.com/hisham.alnour',
      twitter: 'https://twitter.com/hisham_alnour',
      linkedin: 'https://linkedin.com/in/hisham-alnour'
    }
  },
  { 
    name: 'أ. سلمى الدرديري', 
    role: 'باحثة قانونية وحقوقية', 
    avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=200&h=200&fit=crop',
    website: 'salma-dardiri.sd',
    email: 'contact@salma-dardiri.sd',
    socials: {
      facebook: 'https://facebook.com/salma.dardiri',
      twitter: 'https://twitter.com/salma_dardiri',
      linkedin: 'https://linkedin.com/in/salma-dardiri'
    }
  }
];
